import { organizationStatus, orgRepresentativeStatus } from 'constants/index'

export const chipStyleForOrgRepresentative = (status) => {
  switch (status) {
    case orgRepresentativeStatus.NOT_NOTIFIED:
      return {
        style: {
          backgroundColor: '#fff3e0',
          color: '#e65100',
          border: '1px solid #ffcc80',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '4px 10px',
          boxShadow: '0px 2px 4px rgba(255,111,0,0.2)'
        }
      }
    case orgRepresentativeStatus.NOTIFIED:
      return {
        style: {
          backgroundColor: '#e1f5fe',
          color: '#0277bd',
          border: '1px solid #81d4fa',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(3,155,229,0.2)'
        }
      }
    case orgRepresentativeStatus.REGISTERED:
      return {
        style: {
          backgroundColor: '#e0f2f1',
          color: '#00695c',
          border: '1px solid #80cbc4',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '4px 10px',
          boxShadow: '0px 2px 4px rgba(0,137,123,0.2)'
        }
      }
    default:
      return {
        style: {
          backgroundColor: '#f5f5f5',
          color: '#424242',
          border: '1px solid #bdbdbd',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '4px 10px',
          boxShadow: '0px 2px 4px rgba(0,0,0,0.12)'
        }
      }
  }
}

export const chipStyleForOrganization = (status) => {
  switch (status) {
    case organizationStatus.INVITE_NOT_SENT:
      return {
        style: {
          backgroundColor: '#f5f5f5',
          color: '#424242',
          border: '1px solid #bdbdbd',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(0,0,0,0.12)'
        }
      }
    case organizationStatus.AWAITING_RESPONSE:
      return {
        style: {
          backgroundColor: '#e1f5fe',
          color: '#0277bd',
          border: '1px solid #81d4fa',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(3,155,229,0.2)'
        }
      }
    case organizationStatus.PENDING_DATA_REVIEW:
      return {
        style: {
          backgroundColor: '#fff3e0',
          color: '#e65100',
          border: '1px solid #ffcc80',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(255,111,0,0.2)'
        }
      }
    case organizationStatus.APPROVED:
      return {
        style: {
          backgroundColor: '#e0f2f1',
          color: '#00695c',
          border: '1px solid #80cbc4',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(0,137,123,0.2)'
        }
      }
    default:
      return {
        style: {
          backgroundColor: '#f5f5f5',
          color: '#424242',
          border: '1px solid #bdbdbd',
          fontWeight: 'bold',
          borderRadius: '16px',
          padding: '3px 8px',
          boxShadow: '0px 2px 2px rgba(0,0,0,0.12)'
        }
      }
  }
}
